import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import {useTranslation} from "react-i18next";
import Grid from '@mui/material/Grid';
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import {gpsPosColor, gpsPosString, getCoordStr} from './Geoloc.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {latIsValid, longIsValid} from './Util.js';
import MapDialog from './MapDialog.js';
import {getCityName} from './Trans.js';
import {COMM_OK} from './WsR2.js';

let saving = 0;

export const dstTypes = [
	{id:1,  dst_desc: 'dest.not_defined'},
	{id:10, dst_desc: 'dest.bird_watching_tower'},
	{id:11, dst_desc: 'dest.swamp'},
	{id:12, dst_desc: 'dest.mountain'},
];

const DestDialog = observer((props) => {
	const [dstMapOpen, setDstMapOpen] = useState(false);
	const {isOpen, handleClose} = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let timeout;

	function destRxWs(status, msg) {
		saving = 0;

		if (status !== COMM_OK) {
			alert('Destination Rx timeout!');
			return -1;
		}

		if (msg.cmd === 'reg') {
			if (msg.op === 'save') {
				if (msg.result === 'OK') {
					handleClose(true);
				} else {
					alert('Destination save failed!');
				}
			} else if (msg.op === 'del') {
				if (msg.result === 'OK') {
					handleClose(true);
				} else {
					alert('Destination delete failed!');
				}
			} else {
				console.error('destRxWs: unknown operation:', msg.cmd, msg.op);
			}
		} else if (msg.cmd === 'geo') {
			if (msg.op === 'city') {
				if (msg.result === 'OK') {
					if (typeof(msg.data.city) === 'object') {
						gStorage.destination.setCity(msg.data.city);
					}
				} else {
					alert('destRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('destRxWs: unknown operation:', msg.cmd, msg.op);
			}
		} else {
			console.error('destRxWs: unknown cmd', msg.cmd, msg.op);
		}
	}

	function dstNameChanged(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.destination.dest.name = e.target.value;
		gStorage.destination.modified = true;
	}

	function dstDlgGetCityName(city) {
		return getCityName(city, gStorage.conn.user);
	}

	function dstCityChanged(event, city) {
		if (!gStorage.conn.online)
			return;

		if (city) {
			gStorage.destination.dest.city_id = city.id;
		} else {
			gStorage.destination.dest.city_id = 0;
		}

		gStorage.destination.city = city;
		gStorage.destination.modified = true;
	}

	function dstTypeChanged(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.destination.dest.reg_type = parseInt(e.target.value, 10);
		gStorage.destination.modified = true;
	}

	function dstGpsPos2Dst(e) {
		return dstSetPos({lat: gStorage.gps.pos.latitude, lng: gStorage.gps.pos.longitude})
	}

	function dstOpenMap(e) {
		setDstMapOpen(true);
	}

	function dstAddrChanged(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.destination.dest.address = e.target.value;
		gStorage.destination.modified = true;
	}

	function dstDescChanged(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.destination.dest.description = e.target.value;
		gStorage.destination.modified = true;
	}

	function dstPublicChanged(e, value) {
		if (!gStorage.conn.online)
			return;

		gStorage.destination.dest.public_loc = value ? 1 : 0;
		gStorage.destination.modified = true;
	}

	function delayedAddressQuery(e) {
// 		console.log('delayedAddressQuery');

		if (timeout)
			clearTimeout(timeout);

      		timeout = setTimeout(() => {console.log('delayedAddressQuery')}, 300);
	}

	function dstLatValid() {
		return latIsValid(gStorage.destination.latStr);
	}

	function dstLatChanged(e) {
		let valid, latStr = e.target.value;

		valid = latIsValid(latStr);
		if (!valid) {
			gStorage.destination.latStr = latStr;
			gStorage.destination.modified = true;
			return;
		}

		dstSetPos({lat: Number(latStr), lng: gStorage.destination.dest.long_obs / 1000000.0});
	}

	function dstLongValid() {
		return longIsValid(gStorage.destination.longStr);
	}

	function dstLongChanged(e) {
		let valid, longStr = e.target.value;

		valid = longIsValid(longStr);
		if (!valid) {
			gStorage.destination.longStr = longStr;
			gStorage.destination.modified = true;
			return;
		}

		dstSetPos({lat: gStorage.destination.dest.lat_obs / 1000000.0, lng: Number(e.target.value)});
	}

	function dstMapClose() {
		setDstMapOpen(false);
	}
	
	function dstSetPos(pos) {
// 		console.log('dstSetPos', pos);
		let lat = Math.round(Number(pos.lat) * 1000000.0);
		let long = Math.round(Number(pos.lng) * 1000000.0);

		gStorage.destination.dest.lat_obs = lat;
		gStorage.destination.latStr = getCoordStr(lat);

		gStorage.destination.dest.long_obs = long;
		gStorage.destination.longStr = getCoordStr(long);

		gStorage.destination.modified = true;
		
		if (!gStorage.conn.online)
			return;

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'geo',
			op: 'city',
			data: {
				coord: {
					lat: lat,
					long: long,
				},
				city_only_allowed: 0
			},
		};

		gStorage.conn.ws.send(msg, destRxWs);
	}

	function saveDest() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'reg',
			op: 'save',
			data: {
				reg: gStorage.destination.dest,
			}
		};

		saving = 1;
		gStorage.conn.ws.send(msg, destRxWs);
// 		console.log('saveDest', msg);
	}

	function delDest() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'reg',
			op: 'del',
			data: {
				reg: gStorage.destination.dest,
			}
		};

		saving = 1;
		gStorage.conn.ws.send(msg, destRxWs);
	}

	return (
        	<Dialog onClose={() => handleClose(false)} aria-labelledby="dest-dialog" open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('dest.dest')}</Typography>
						<IconButton edge="start" color="inherit" onClick={() => handleClose(false)} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('common.name')}
						variant="outlined"
						value={gStorage.destination.dest.name}
						onChange={action((e) => dstNameChanged(e))}
						size="small"
						style={{width: 300, margin: 4, marginTop: 16}} 
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel style={{width: 300, margin: 4}}>{t('dest.type')}</InputLabel>
						<Select
							value={gStorage.destination.dest.reg_type}
							onChange={action((e, type) => dstTypeChanged(e, type))}
							style={{width: 300, margin: 4}}
						>
						{
							dstTypes.map((dt, ind) => {
								return (<MenuItem key={dt.id} value={dt.id}>{t(dt.dst_desc)}</MenuItem>);
							})
						}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField label={t('gps.position')} size="small" variant="outlined" 
						style={{width: 300, margin: 4, backgroundColor: gpsPosColor(gStorage.gps)}}
					value={gpsPosString(gStorage.gps)} />
				</Grid>
				<Grid size={{xs: 12}}>
					<Button variant="contained" color="primary" size="small" style={{width:143, margin: 4}} onClick={action((e) => dstGpsPos2Dst(e))}>{t('gps.update')}</Button>
					<Button variant="contained" color="primary" size="small" style={{width:143, margin: 4}} onClick={dstOpenMap}>{t('gps.map')}</Button>
				</Grid>
				<Grid size={{xs: 12}}>
					<TextField 
						label={t('gps.lat')} 
						size="small" 
						variant="outlined" 
						style={{width: 143, margin: 4}} 
						value={gStorage.destination.latStr} 
						onKeyUp={delayedAddressQuery}
						onKeyDown={() => {if (timeout) clearTimeout(timeout);}}
						onChange={action((e) => dstLatChanged(e))} 
						error={!dstLatValid()}/>

					<TextField
						label={t('gps.long')} 
						size="small" 
						variant="outlined" 
						style={{width: 143, margin: 4}} 
						value={gStorage.destination.longStr}
						onKeyUp={delayedAddressQuery}
						onKeyDown={() => {if (timeout) clearTimeout(timeout);}}
						onChange={action((e) => dstLongChanged(e))}
						error={!dstLongValid()}/>
				</Grid>


				{/* <Geoloc {...props} cityChange={dstCityChanged} /> */}
				<Grid size={{xs: 12}} align={'center'}>
					<Autocomplete
						options={gStorage.lists.citylist.list}
						getOptionLabel={option => dstDlgGetCityName(option)}
						value={gStorage.destination.city}
						onChange={action((e, city) => dstCityChanged(e, city))}
						error={gStorage.destination.dest.city_id <= 0 ? 1 : 0}
						disableClearable
						style={{width: 300, margin: 4}}
						renderInput={params => (
							<TextField {...params} label={t('add.city')} variant="outlined" size="small" fullWidth />
						)} />
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('add.address')}
						value={gStorage.destination.dest.address}
						onChange={action((e) => dstAddrChanged(e))}
						style={{width: 300, margin: 4}} 
						variant="outlined" 
						inputProps={{maxLength: 256}}
						size="small" />
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('dest.description')}
						variant="outlined"
						value={gStorage.destination.dest.description}
						onChange={action((e) => dstDescChanged(e))}
						multiline rows="4" 
						size="small" 
						inputProps={{maxLength: 8192}}
						style={{width: 300, margin: 4}} 
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('dest.public')}
						labelPlacement="start"
						checked={!!gStorage.destination.dest.public_loc}
						onChange={action((e, value) => dstPublicChanged(e, value))}
						control={<Checkbox color="primary" />}
						style={{margin: 4}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<div>
						<Button 
							variant="contained" 
							color="primary" 
							size="small" 
							style={{width:143, margin: 4}} 
							disabled={
								!gStorage.conn.online ||
								gStorage.destination.dest.id === undefined || 
								gStorage.destination.dest.id === null || 
								gStorage.destination.dest.user_id !== gStorage.conn.user.id || 
								gStorage.destination.dest.name.length <= 0 ||
								gStorage.destination.dest.city_id <= 0 ||
								!latIsValid(gStorage.destination.latStr) || 
								!longIsValid(gStorage.destination.longStr) || 
								!gStorage.destination.modified || 
								saving > 0}
							onClick={saveDest}>
								{t('dest.save')}
						</Button>
						<Button 
							variant="contained" 
							color="primary" 
							size="small" 
							style={{width:143, margin: 4}} 
							disabled={
								!gStorage.conn.online ||
								!gStorage.destination.dest.id || 
								gStorage.destination.dest.id === 0 || 
								gStorage.destination.dest.user_id !== gStorage.conn.user.id || 
								saving > 0}
							onClick={delDest}>
								{t('dest.delete')}
						</Button>
					</div>
				</Grid>
			</Grid>

			<MapDialog 
				mapOpen={dstMapOpen} 
				onClose={dstMapClose} 
				pos={[gStorage.destination.dest.long_obs / 1000000.0, gStorage.destination.dest.lat_obs / 1000000.0]} 
				setPos={action((pos) => dstSetPos(pos))}/>

		</Dialog>
	);
});

export default DestDialog;
